(function () {
  const drawer = document.getElementById('menu-drawer');
  if (!drawer) return;

  const desktopBreakpoint = 1000;

  const stageColumn = drawer.querySelector('[data-detail-stage-column]');
  const stageBody = drawer.querySelector('[data-detail-body]');
  const backButton = drawer.querySelector('[data-detail-back]');
  const triggers = Array.from(drawer.querySelectorAll('[data-detail-trigger]'));
  const sources = Array.from(drawer.querySelectorAll('[data-detail-source]'));
  const externalTriggers = Array.from(document.querySelectorAll('[data-drawer-trigger]'));
  const defaultDrawerActivator = document.querySelector('.header__primary-nav > button[aria-controls="menu-drawer"]');

  if (!stageColumn || !stageBody || !backButton || triggers.length === 0) return;

  let openObserver = null;
  let openRequestedFromTopNav = false;

  const isDesktop = () => window.innerWidth >= desktopBreakpoint;
  const isDrawerOpen = () => drawer.hasAttribute('open');

  function clearActive() {
    triggers.forEach((trigger) => trigger.classList.remove('is-active'));
  }

  function cleanupObserver() {
    if (openObserver) {
      openObserver.disconnect();
      openObserver = null;
    }
  }

  function resetDrawerDetailState() {
    drawer.classList.remove('is-detail-open');
    stageColumn.hidden = true;
    stageBody.innerHTML = '';
    clearActive();
    cleanupObserver();
    openRequestedFromTopNav = false;
  }

  function getSourceById(id) {
    return sources.find((source) => source.getAttribute('data-detail-source') === id);
  }

  function getTriggerByKey(key) {
    return triggers.find((trigger) => trigger.getAttribute('data-detail-key') === key);
  }

  function openDetail(id, trigger) {
    const source = getSourceById(id);
    if (!source) return false;

    stageBody.innerHTML = source.innerHTML;
    stageColumn.hidden = false;

    requestAnimationFrame(() => {
      drawer.classList.add('is-detail-open');
    });

    clearActive();

    if (trigger) {
      trigger.classList.add('is-active');
    }

    return true;
  }

  function openDetailByKey(key) {
    const matchingTrigger = getTriggerByKey(key);
    if (!matchingTrigger) {
      console.warn('No matching drawer trigger found for key:', key);
      return false;
    }

    const detailId = matchingTrigger.getAttribute('data-detail-id');
    if (!detailId) {
      console.warn('No detail id found for key:', key);
      return false;
    }

    return openDetail(detailId, matchingTrigger);
  }

  function switchDetailByKey(key) {
    resetDrawerDetailState();

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        openDetailByKey(key);
      });
    });
  }

  function openDrawerAndThenShowDetail(key) {
    resetDrawerDetailState();
    openRequestedFromTopNav = true;

    openObserver = new MutationObserver(() => {
      if (!isDrawerOpen()) return;

      cleanupObserver();

      requestAnimationFrame(() => {
        const opened = openDetailByKey(key);
        if (!opened) {
          resetDrawerDetailState();
        } else {
          openRequestedFromTopNav = false;
        }
      });
    });

    openObserver.observe(drawer, {
      attributes: true,
      attributeFilter: ['open']
    });

    if (defaultDrawerActivator) {
      defaultDrawerActivator.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        })
      );
    } else if (typeof drawer.show === 'function') {
      drawer.show();
    } else {
      resetDrawerDetailState();
      console.warn('No default drawer activator found for #menu-drawer');
    }
  }

  drawer.addEventListener(
    'click',
    function (event) {
      const trigger = event.target.closest('[data-detail-trigger]');
      if (!trigger) return;
      if (!isDesktop()) return;

      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      const id = trigger.getAttribute('data-detail-id');
      if (!id) return;

      openDetail(id, trigger);
      openRequestedFromTopNav = false;
    },
    true
  );

  backButton.addEventListener('click', function (event) {
    if (!isDesktop()) return;

    event.preventDefault();
    resetDrawerDetailState();
  });

  externalTriggers.forEach((link) => {
    link.addEventListener(
      'click',
      function (event) {
        if (!isDesktop()) return;

        const key = link.getAttribute('data-drawer-target');
        if (!key) return;

        event.preventDefault();
        event.stopPropagation();

        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }

        if (isDrawerOpen()) {
          switchDetailByKey(key);
          return;
        }

        openDrawerAndThenShowDetail(key);
      },
      true
    );
  });

  if (defaultDrawerActivator) {
    defaultDrawerActivator.addEventListener(
      'click',
      function () {
        if (!isDesktop()) return;

        if (!openRequestedFromTopNav) {
          resetDrawerDetailState();
        }
      },
      true
    );
  }

  drawer.addEventListener('dialog:after-hide', function () {
    resetDrawerDetailState();
  });

  window.addEventListener('resize', function () {
    if (!isDesktop()) {
      resetDrawerDetailState();
    }
  });
})();